module.exports = __webpack_public_path__ + "static/media/K.9dd42136.png";